import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { MsauthComponent } from './msauth/msauth/msauth.component';


const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled'
};

const routes: Routes = [
     { path: '', redirectTo: 'account', pathMatch: 'full' },
  // load auth module lazily
  { path: 'account', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: 'auth', component: MsauthComponent } ,
  {
    path: '', component: AppLayoutComponent,
    children: [
        { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
        { path: 'jobs', loadChildren: () => import('./jobs/jobs/jobs.module').then(m => m.JobsModule) },
        { path: '', loadChildren: () => import('./jobs/create-job/create-job.module').then(m => m.CreateJobModule) },
        { path: '', loadChildren: () => import('./docreport/doc-report.module').then(m => m.DocReportModule) },
        { path: '', loadChildren: () => import('./jobs/error/error.module').then(m => m.ErrorModule) },
        { path: '', loadChildren: () => import('./jobs/edit-job/edit-job.module').then(m => m.EditJobModule) },
        { path: 'work-order-received', loadChildren: () => import('./doc/work-order-received/work-order-received.module').then(m => m.WorkOrderReceivedModule) },
        { path: 'work-orders-central', loadChildren: () => import('./doc/work-orders-central/work-orders-central.module').then(m => m.WorkOrdersCentralModule) },
        { path: '', loadChildren: () => import('./doc/view-work-orders/view-work-orders.module').then(m => m.ViewWorkOrdersModule) },
        { path: '', loadChildren: () => import('./materials-sor/materials/materials.module').then(m => m.MaterialsModule) },
        { path: '', loadChildren: () => import('./materials-sor/sor/sor.module').then(m => m.SorModule) },
        { path: '', loadChildren: () => import('./setup/status/status.module').then(m => m.StatusModule) },
        { path: 'business', loadChildren: () => import('./setup/customers/business/business.module').then(m => m.BusinessModule) },    
        { path: '', loadChildren: () => import('./setup/sites/sites.module').then(m => m.SitesModule) },
        { path: '', loadChildren: () => import('./setup/create-checklist/create-checklist.module').then(m => m.CreateChecklistModule) },
        { path: 'material-visibility', loadChildren: () => import('./setup/material-visibility/material-visibility.module').then(m => m.MaterialVisibilityModule) },
        { path: '', loadChildren: () => import('./setup/users/users.modules').then(m => m.UsersModule) },
        { path: 'price-list-margins', loadChildren: () => import('./setup/price-list-margins/price-list-margins.module').then(m => m.PriceListMarginsModule) },
        { path: 'user-access-role', loadChildren: () => import('./setup/user-access-role/user-access-role.module').then(m => m.UserRoleModule) },
        { path: 'myjob', loadChildren: () => import('./contractorscreen/edit-job/myjob/myjob.module').then(m => m.MyJobModule) },
        { path: '', loadChildren: () => import('./contractorscreen/edit-job/job-info/job-info.module').then(m => m.JobInfoModule) },
        { path: '', loadChildren: () => import('./contractorscreen/edit-job/edit-job.module').then(m => m.EditJobModule) },
        { path: '', loadChildren: () => import('./contractorscreen/new-materials/new-materials.module').then(m => m.NewMaterialsModule) },
       //  { path: '', loadChildren: () => import('./docreport/doc-report.module').then(m => m.DocReportModule) },
      ]
  },   
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }